<template>
  <div>
    <v-row v-if="$vuetify.breakpoint.mdAndUp">
      <v-col
        cols="12"
        class="col-sm-3 mt-12"
        v-for="lector in data"
        :key="lector.id"
      >
        <lector :person="lector"></lector>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col cols="12" v-for="lector in data" :key="lector.id">
        <lector-card-small :lector="lector"></lector-card-small>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Lector from "@/components/lector";
import LectorCardSmall from "@/components/LectorCardSmall";

export default {
  name: "SpeakerSlider",
  props: ["data"],
  components: { LectorCardSmall, Lector }
};
</script>

<style scoped lang="scss"></style>
